import { Component, OnInit } from '@angular/core';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { PartPurchaseAttachment } from 'app/core/model/entity-model';
import DataSource from 'devextreme/data/data_source';
import { alert } from 'devextreme/ui/dialog';
import { environment } from 'environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-part-purchase-dialog',
    templateUrl: './part-purchase-dialog.component.html',
    styleUrls: ['./part-purchase-dialog.component.scss'],
    standalone: false
})
export class PartPurchaseDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    partsDS: DataSource;

    partPurchase: any;
    partId: any;
    selectedPart: any;
    quantity: number;
    quantityDisabled = false;

    attachments: PartPurchaseAttachment[] = [];
    uploadUrl = `${environment.serviceName}/file/SavePartPurchaseAttachmentToBlobStorage`;
    uploadHeader: any;
    uploadsInProgress = 0;

    processing = false;
    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private auth: AuthService,
    ) {}

    async ngOnInit() {
        this.uploadHeader = { Authorization: `Bearer ${this.auth.currentUser.jwtToken}` };
        if (this.selectedPart) {
            this.selectedPart.projectedInventory = this.selectedPart.inStock - this.selectedPart.allocated;
        }
        if (!this.partPurchase) {
            this.partPurchase = this.uow.partPurchases.createEntity();
            this.partPurchase.date = new Date();
            this.partPurchase.price = !!this.selectedPart ? this.selectedPart.cost : 0.0;

            this.partPurchase.inStock = this.selectedPart.inStock ?? 0;
            this.partPurchase.allocated = this.selectedPart.allocated;
            this.partPurchase.projectedInventory = this.selectedPart.projectedInventory;

            this.partPurchase.createdBy = this.auth.currentUser.userName;
            if (!!this.partId) this.partPurchase.partId = this.partId;
        } else {
            this.quantityDisabled = true;
        }
        this.partsDS = new DataSource({
            store: (await this.uow.getParts()) as any[],
            paginate: true,
        });
    }

    async save() {
        this.processing = true;
        this.partPurchase.quantity = this.quantity;
        await this.uow.commit();
        this.result.next({ success: true, partId: this.partPurchase.partId, quantity: this.partPurchase.quantity });
        this.modalRef.hide();
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }

    uploadStarted(e) {
        this.uploadsInProgress++;
    }

    uploaded(e) {
        if (e?.request?.responseText) {
            const fileResponses = JSON.parse(e.request.responseText) as { filename: string; name: string }[];
            for (const fileResponse of fileResponses) {
                const attachment = this.uow.partPurchaseAttachments.createEntity({
                    partPurchaseId: this.partPurchase.id,
                    name: fileResponse.name,
                    filename: fileResponse.filename,
                    created: new Date(),
                    createdBy: this.auth.currentUser.userName,
                });
                this.attachments.push(attachment);
            }
        }
        this.uploadsInProgress--;
    }

    uploadError(e) {
        this.uploadsInProgress--;
        alert('An error occurred while attempting to upload the file(s)', 'Upload Error');
    }

    removeAttachment(e: any, attachment: PartPurchaseAttachment) {
        e.preventDefault();
        attachment.entityAspect.setDeleted();
        this.attachments.splice(this.attachments.indexOf(attachment), 1);
    }

    openAttachment(attachment: PartPurchaseAttachment) {
        window.open(attachment.filename, '_blank');
    }
}
